import { Component, input } from '@angular/core';
import { SafePipe } from 'safe-pipe';

@Component({
  selector: 'app-stock-view03',
  standalone: true,
  imports: [SafePipe],
  templateUrl: './stock-view03.component.html',
  styleUrl: './stock-view03.component.scss'
})
export class StockView03Component {
  readonly website = input<string>('capital'); // capital, twse, tpex
readonly stockno = input<string>('2330');
get urlPath(): string {
  switch (this.website()) {
    case 'capital':
      return `https://www.capital.com.tw/web/#/stock-analysis/stock-profile;stockSymbol=${this.stockno()}`;
    case 'twse':
      return `https://www.twse.com.tw/zh/stockSearch/stockSearch`;
    case 'tpex':
      return `https://www.tpex.org.tw/web/stock/aftertrading/otc_quotes_no1430/stk_quote.php?l=zh-tw&d=`;
    default:
      return '';
  }
}

}
